import { useState } from "react";
import { Box, Modal } from "@mui/material";
import ProjectContent from "../Project/ProjectContent";
import { modalStyle } from "src/styles/globalStyles";
import Image from "next/image";
import ProjectCardContent from "../Project/ProjectCardContent";

interface InspirationsItem {
  item: any;
  isFeedback: any;
}

const InspirationsItem = ({ item, isFeedback }: InspirationsItem) => {
  const [openReadOnly, setOpenReadOnly] = useState(false);

  return (
    <>
      <Modal open={openReadOnly} onClose={() => setOpenReadOnly(false)}>
        <Box
          className="bg-surface"
          // @ts-ignore
          sx={{ ...modalStyle }}
        >
          <ProjectContent
            project={item}
            isFeedback={isFeedback}
            close={() => setOpenReadOnly(false)}
          />
        </Box>
      </Modal>

      <div className="inspire__item">
        <div className="inspire__item--image">
          {item?.images && item?.images.length > 0 && (
            <Image
              src={item?.images[0]}
              alt=""
              width="100"
              height="100"
              layout="responsive"
            />
          )}
        </div>

        <ProjectCardContent
          project={item}
          onOpen={() => setOpenReadOnly(true)}
        />
      </div>
    </>
  );
};

export default InspirationsItem;
